import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-mobile",
  templateUrl: "./med-icon-mobile.component.html",
})
export class MedIconMobileComponent extends SvgMixinComponent {}
